/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 9/29/13
 * Time: 5:28 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var GoogleAnalyticsProfileUrlModel = require("manager-components/google-analytics/models/GoogleAnalyticsProfileUrlModel");
    var BaseCollection = require("collections/BaseCollection");
    var LEResourceResolver = require("leResourceResolver");
    var Logger = require("logger");

    var GoogleAnalyticsProfileUrlsCollection = BaseCollection.extend({
        model: GoogleAnalyticsProfileUrlModel,
        apiResource: LEResourceResolver.apiResources.AnalyticsDataSources.googleAnalyticsProfileUrls,
        resource: function() {
            return LEResourceResolver.extendResourceWithOptions.call(this, this.apiResource, {profileId: this.profileId});
        },

        initialize: function(options) {
            this._validateOptions(options);
            this.profileId = options.profileId;
        },

        _validateOptions: function(options) {
            if(!_.has(options, "profileId")) {
                var logger = Logger.getLogger("AnalyticsDataSources");
                logger.error("Invalid options in GoogleAnalyticsProfileUrlsCollection: profileId is mandatory", "GoogleAnalyticsProfileUrlsCollection:_validateOptions");
                logger.graph({name:"manager:GoogleAnalyticsProfileUrlModel:_validateOptions:profileId"});
                throw "GoogleAnalyticsProfileUrlsCollection >> initialize >> _validateOptions >> profileId is mandatory.";
            }
        }
    });

    return GoogleAnalyticsProfileUrlsCollection;
});
